import Plyr from 'plyr/dist/plyr.min'

export default {
  init() {
    // JavaScript to be fired on the home page
    $(".wp-block-image").each(function() {
      let caption = $(this).find('figcaption').text();
      if (caption !== "") {
        $(this).tooltipster({
          content: caption,
          delay: 0,
          maxWidth: 350,
          plugins: ['follower'],
          theme: ['tooltipster-noir', 'tooltipster-noir-customized']
        });
      }
    });

    const player = new Plyr(document.querySelector('video'));
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-project.js